import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss']
})
export class AddUsersComponent implements OnInit {

  
  addUserForm: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { 
    this.addUserForm = new FormGroup({
      userName: new FormControl(),
      userEmail: new FormControl(),
      userMobileNo: new FormControl(),
      tenantCode: new FormControl(),
      orgCode: new FormControl(),
      associateName: new FormControl(),
      branchName: new FormControl(),
      roleType: new FormControl(),
    });
  }

  ngOnInit(): void {
  }

  addUserData(data) {
console.log(`addUserData`,data)
  }

  modelClose()
  {
    this.modal.close();
  }

}
